import { Component, input, InputSignal } from '@angular/core';

import { MDContentBoxComponent, MDIconComponent } from '@melodic-ui/components';
import { IconRef } from '@melodic-ui/types';

@Component({
	selector: 'lb-detail-widget',
	standalone: true,
	imports: [MDIconComponent, MDContentBoxComponent],
	templateUrl: './details-widget-component.html',
	styleUrl: './details-widget-component.scss'
})
export class DetailsWidgetComponent {
	public iconName: InputSignal<IconRef | undefined> = input.required<IconRef | undefined>();
}
